import React from 'react';
import PropTypes from 'prop-types';
import Route from 'react-router-dom/Route';
import Redirect from 'react-router-dom/Redirect';
import { connect } from 'react-redux';

import { state } from '../../redux/sagas/aws-cognito-redux-saga';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      rest.auth.isSignedIn !== state.AUTH_FAIL ? (
        <Component {...props} />
      ) : (
        <Redirect
          // to={{ pathname: `/${rest.computedMatch.params.locale}/stylist/login`, state: { from: props.location } }}
          to={{
            pathname: `/${rest.computedMatch.params.locale}/salon-consultation/login`,
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  auth: PropTypes.shape({
    isSignedIn: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({}).isRequired,
};

const mapStatetoProps = state => ({
  auth: state.auth,
});

const mapDispatchToProps = () => ({});

export default connect(mapStatetoProps, mapDispatchToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/PrivateRoute.js